import {
  ComponentRef,
  Directive,
  Inject,
  Input,
  OnChanges,
  OnDestroy,
  SimpleChanges,
} from '@angular/core';

import { toggleCssClass } from '@recruitee/common';

import { SpinnerComponent } from '../../../spinner/spinner.component';
import { ExtendableButton, setInputs } from '../../button.types';

@Directive({
  standalone: true,
  selector:
    'rt-button[loading], a[rt-button][loading], rt-icon-button[loading], a[rt-icon-button][loading]',
})
export class ButtonLoadingDirective implements OnChanges, OnDestroy {
  @Input() public loading: boolean = false;

  private spinnerComponentRef: ComponentRef<SpinnerComponent> | null = null;
  private toggleLoadingClass = toggleCssClass('loading', () => this.loading);

  constructor(@Inject(ExtendableButton) private button: ExtendableButton) {}

  public ngOnChanges(changes: SimpleChanges) {
    if (changes.loading) {
      this.toggleSpinner();
      this.toggleLoadingClass.toggleIfCondition();
    }
  }

  public ngOnDestroy() {
    if (this.spinnerComponentRef) {
      this.spinnerComponentRef.destroy();
    }
  }

  public toggleSpinner() {
    if (this.loading) {
      this.spinnerComponentRef = this.button.secondarySlot.createComponent(SpinnerComponent);
      setInputs(this.spinnerComponentRef, { variant: 'small' });
    } else if (this.spinnerComponentRef) {
      this.spinnerComponentRef.destroy();
      this.spinnerComponentRef = null;
    }
  }
}
